import { $themeBreakpoints } from '@themeConfig'
import { defineStore } from 'pinia'

export const useAppStore = defineStore('AppStore', {
  state: () => {
    return {
      windowWidth: 0,
      shallShowOverlay: false,
    }
  },
  getters: {
    currentBreakPoint() {
      if (this.windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (this.windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (this.windowWidth >= $themeBreakpoints.md) return 'md'
      if (this.windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  actions: {
    updateWindowWidth(val) {
      this.windowWidth = val
    },
    toggleOverlay(val) {
      this.shallShowOverlay = val !== undefined ? val : !this.shallShowOverlay
    },
  },
})
